import PagodaCharts from './charts';
import camelCase from 'camelcase';
import { getFileNameInPath } from './utils/util';
var version = '1.0.2';
var themeConf = {};

(function (r) {
  return r.keys().map(function (sourcePath) {
    var fileName = getFileNameInPath(sourcePath, /.js/); // 转驼峰

    var configName = camelCase(fileName);
    themeConf[configName] = r(sourcePath)["default"];
  });
})(require.context('./theme', true, /.js$/));

function initTheme(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$colorStartIn = _options.colorStartIndex,
      colorStartIndex = _options$colorStartIn === void 0 ? 0 : _options$colorStartIn;
  themeConf.color = themeConf.color.slice(colorStartIndex, themeConf.color.length);
  return themeConf;
}

function install(Vue, opt) {
  var theme = initTheme(opt);
  opt.echarts.registerTheme('pagoda-echarts-theme', theme);
  PagodaCharts.echarts = opt.echarts;
  Vue.component(PagodaCharts.name, PagodaCharts);
}

if (typeof window !== 'undefined' && window.Vue && window.echarts) {
  install(window.Vue, {
    echarts: window.echarts
  });
}

export { version, install, PagodaCharts };
export default {
  version: version,
  install: install,
  PagodaCharts: PagodaCharts
};